import React, { useEffect } from "react";
import { pathOr } from "ramda";

import useGrid from "@/hooks/Grid";
import { useLowGPU } from "@/store/ui/ui.hooks";

import franchise1Grid from "@/assets/grids/franchise_1.json";

import propTypes from "./Franchise.propTypes";
import defaultProps from "./Franchise.defaultProps";

import {
	ProductGroupingPartialsTitle,
	ProductGroupingPartialsDescription,
	ProductGroupingPartialsBack,
	ProductGroupingPartialsLogo,
	ProductGroupingPartialsImage,
} from "../Partials";

const Franchise1 = ({ data, lang }) => {
	const { isGridLoading, start: startGrid, end: endGrid, shouldRerenderGrid } = useGrid();
	const lowGPU = useLowGPU();

	// #region LIFECYCLE HOOKS
	useEffect(() => {
		endGrid();
		startGrid(franchise1Grid);
	}, [isGridLoading]);
	// #endregion LIFECYCLE HOOKS

	// #region RENDER
	return (
		!shouldRerenderGrid &&
		!isGridLoading && (
			<>
				<ProductGroupingPartialsImage
					id="FranchiseRightTop"
					src={pathOr(null, ["assets", 0, "portrait"], data)}
					shouldShowBottom
				/>

				<ProductGroupingPartialsDescription id="FranchiseRightBottom" data={data} />

				<ProductGroupingPartialsTitle id="FranchiseRightCenter" data={data} lang={lang} lowGPU={lowGPU} />

				<ProductGroupingPartialsImage
					id="FranchiseLeftPrimary"
					src={pathOr(null, ["assets", 1, "portrait"], data)}
					shouldShowBottom
					delay={0.15}
				/>

				<ProductGroupingPartialsBack id="FranchiseNavA" />

				<ProductGroupingPartialsImage
					id="FranchiseNavB"
					src={pathOr(null, ["assets", 2, "portrait"], data)}
					shouldShowBottom
					delay={0.3}
				/>

				<ProductGroupingPartialsLogo id="FranchiseLeftCenter" data={data} lowGPU={lowGPU} />
			</>
		)
	);
	// #endregion RENDER
};

Franchise1.propTypes = propTypes;
Franchise1.defaultProps = defaultProps;

export default Franchise1;
